import { Component, Input } from '@angular/core';
import { Catalog } from '../../../models/catalog/catalog';
import { TextModes } from '../../ui/controls/text-input/text-input.component';
import { FormMode } from '../../../core/constants';
import { CatalogService } from '../../../models/catalog/catalogService';

@Component({
  selector: 'app-catalog',
  standalone: false,
  templateUrl: './catalog.component.html',
})
export class CatalogComponent {
  @Input() data: Partial<Catalog> = Catalog.createEmpty();
  @Input() mode: FormMode = FormMode.View;

  FormMode = FormMode;
  InputTextModes = TextModes;

  constructor(public catalogService: CatalogService) {}

}
